import { toast as t } from 'svelte-french-toast';
import { derived } from 'svelte/store';
import { palette } from './palette.js';
const { remove, dismiss } = t;
export const toast = derived(palette, ($palette) => {
    const { background, text, secondary } = $palette;
    const baseStyle = (border) => `background: ${background}; color: ${text}; border: solid 1px ${border};`;
    const successStyle = {
        style: baseStyle($palette.success),
        iconTheme: {
            primary: $palette.success,
            secondary
        }
    };
    const loadingsStyle = {
        style: baseStyle($palette.loading),
        iconTheme: {
            primary: $palette.loading,
            secondary
        }
    };
    const errorStyle = {
        style: baseStyle($palette.error),
        iconTheme: {
            primary: $palette.error,
            secondary
        }
    };
    const loading = (message, options) => t.loading(message, {
        ...loadingsStyle,
        ...options
    });
    const promise = (promise, message, options) => t.promise(promise, message, {
        ...{
            success: successStyle,
            loading: loadingsStyle,
            error: errorStyle
        },
        ...options
    });
    const plain = (message, options) => t(message, {
        style: baseStyle($palette.loading),
        ...options
    });
    const custom = (message, options) => t.custom(message, {
        style: baseStyle($palette.loading),
        ...options
    });
    const success = (message, options) => t.success(message, {
        ...successStyle,
        ...options
    });
    const error = (message, options) => t.error(message, {
        ...errorStyle,
        ...options
    });
    return {
        promise,
        dismiss,
        plain,
        success,
        error,
        remove,
        custom,
        loading
    };
});
